
import template from '../../../templates/checkout-flow/checkout.directive.tpl.html';

import app from '../../App';

export function checkoutDirective (PromoCodeService,Info,PricingHelper) {
    
    'ngInject';

    return {
        restrict: 'E',
        scope: {
            data: '=',
            taxrate: '='
        },
        templateUrl: template,
        link: ( scope, element, attrs ) => {
            scope.currentStep=parseInt(scope.data.step-1);
            recurly.configure(Info.recurlyPublicKey);
            PricingHelper.getPlans();
            scope.selectedShippingRate={Amount:0};
            scope.purchaseDisabled=true;
            scope.creditCardError='';
            scope.showCreaditCardError=false;
            scope.$watch('data.step',(newValue, oldValue)=>{
                console.log('currentStep changed');
                scope.currentStep=parseInt(scope.data.step-1);
            });
            scope.$watch('data',(newValue, oldValue)=>{
                console.log('billing Token was changed');
                if((scope.data.token=='')||( scope.data.pricingParams.devices>0 && scope.selectedShippingRate.Amount==0)){
                    scope.purchaseDisabled=true;
                }else{
                    scope.purchaseDisabled=false;
                }
                console.log( scope.purchaseDisabled);
            },true);
            scope.$watch('selectedShippingRate',(newValue, oldValue)=>{
                console.log('billing Token was changed');
                if((scope.data.token=='')||( scope.data.pricingParams.devices>0 && scope.selectedShippingRate.Amount==0)){
                    scope.purchaseDisabled=true;
                }else{
                    scope.purchaseDisabled=false;
                }
                console.log( scope.purchaseDisabled);
            },true);
        }
    };
};

app.directive( 'checkoutDirective', checkoutDirective );



// WEBPACK FOOTER //
// ./src/js/directives/checkout-flow/checkout-directive.js